import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SearchBoxComponent } from "src/app/common/components/core/search-box/search-box.component";
import { MatCheckboxChange, MatCheckboxModule } from "@angular/material/checkbox";
import { ButtonComponent, ButtonVariant } from "src/app/common/components/core/button/button.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-cosign-search",
  templateUrl: "./cosign-search.component.html",
  styleUrls: ["./cosign-search.component.scss"],
  imports: [ CommonModule, SearchBoxComponent, MatCheckboxModule, ButtonComponent],
  standalone: true,
})
export class CosignSearchComponent {
  @Input() enableSign: boolean = false;
  @Input() selectionsCount: number = 0;

  @Output() onSearch = new EventEmitter<string>();
  @Output() onShowArchived = new EventEmitter<boolean>();
  @Output() onClickSign = new EventEmitter<void>();

  signBtnConfig = {
    variant: ButtonVariant.PRIMARY,
    text: 'Sign'
  }

  search(value: string): void {
    this.onSearch.emit(value);
  }

  showArchivedClicked(event: MatCheckboxChange): void {
    this.onShowArchived.emit(event.checked);
  }

  SignClicked(): void {
    this.onClickSign.emit();
  }
}
